export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11454.bdf00f81.jpg";